"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var index_1 = __importStar(require("../Colors/index"));
var index_2 = __importDefault(require("../Icon/index"));
// tslint:disable-next-line:variable-name
var Badge = function (props) {
    var icon = props.icon, color = props.color, children = props.children, className = props.className;
    var cn = classnames_1.default("respectkit__badge", index_1.default(color || index_1.BaseColor.LightBlue), {
        with_icon: icon != null,
    }, className);
    var iconItem = null;
    if (icon != null) {
        iconItem = react_1.default.createElement(index_2.default, { icon: icon });
    }
    return (react_1.default.createElement("div", { className: cn },
        iconItem,
        react_1.default.createElement("span", null, children)));
};
exports.default = Badge;
//# sourceMappingURL=index.js.map